<template>
  <div
    class="video-player"
    :style="{
      padding: (typeof content.titleStyle.padding === 'number' && (content.titleStyle.padding + 'rem')) || '',
      paddingTop: (typeof content.titleStyle.paddingTop === 'number' && (content.titleStyle.paddingTop + 'rem')) || '',
      paddingBottom: (typeof content.titleStyle.paddingBottom === 'number' && (content.titleStyle.paddingBottom + 'rem')) || '',
    }"
  >
    <video
      id="myVideo"
      :src="content.url"
      width="100%"
      controls
      :poster="require('@/assets/images/common/video-poster-default.png')"
      webkit-playsinline="true"
      playsinline="true"
      controlsList="nodownload"
      x5-playsinline=""
      x-webkit-airplay="allow"
      x5-video-player-type="h5"
      :style="{
        height: (typeof content.titleStyle.height === 'number' && (content.titleStyle.height + 'rem')) || '422rem',
      }"
    ></video>
  </div>
</template>

<script>
/*
视频播放器
*/
export default {
  name: "videoPlayer",
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    },
  },
  methods: {
    
  }
}
</script>

<style lang="scss" scoped>
.video-player{
  text-indent: 0;

  video{
    width: 100%;
    height: 422rem;
  }
}
</style>